import { DELIMITER } from 'app/shared/constants/AnalyticsDelimiterConstants';

const WILL_GET_CUSTOM_DATA = true;

const CATEGORY = `FindTenants${DELIMITER}Listing`;

const LABEL = {
    CLICK: 'Click',
    OUTBOUND_CLICK: 'OutboundClick',
};

const GA_PREFIX = {
    DEACTIVATE_LISTING: 'DeactivateListing',
    EDIT_LISTING: 'EditListing',
    LEARN_MORE_SYNDICATION: 'LearnMoreSyndication',
    LEARN_MORE_ZESTIMATE: 'LearnMoreZestimate',
    LIST_MY_PROPERTY: 'ListMyProperty',
    OUTBOUND_CLICK: 'OutboundClick',
    VIEW_COMPARABLES: 'ViewComparables',
    VIEW_SYNDICATION_STATUS: 'ViewSyndicationStatus',
};

const GA_EVENTS = {
    SYNDICATION_STATUS_MODAL_CLICK: {
        category: CATEGORY,
        label: LABEL.CLICK,
        // ViewSyndicationStatus::[listing_status]
        action: WILL_GET_CUSTOM_DATA,
    },
    SYNDICATION_STATUS_CLICK: {
        category: CATEGORY,
        // OutboundClick::[brand]
        label: WILL_GET_CUSTOM_DATA,
        // ViewSyndicationStatus::[listing_status]
        action: WILL_GET_CUSTOM_DATA,
    },
    LEARN_MORE_SYNDICATION_CLICK: {
        category: CATEGORY,
        label: LABEL.OUTBOUND_CLICK,
        // LearnMoreSyndication::[listing_status]
        action: WILL_GET_CUSTOM_DATA,
    },
    EDIT_LISTING_CLICK: {
        category: CATEGORY,
        label: LABEL.CLICK,
        // EditListing::[listing_status]
        action: WILL_GET_CUSTOM_DATA,
    },
    DEACTIVATE_LISTING_CLICK: {
        category: CATEGORY,
        label: LABEL.CLICK,
        // DeactivateListing::[listing_status]
        action: WILL_GET_CUSTOM_DATA,
    },
    ZESTIMATE_LEARN_MORE_CLICK: {
        category: CATEGORY,
        label: LABEL.CLICK,
        // LearnMoreZestimate::[listing_status]
        action: WILL_GET_CUSTOM_DATA,
    },
    VIEW_COMPARABLES_CLICK: {
        category: CATEGORY,
        label: LABEL.OUTBOUND_CLICK,
        // ViewComparables::[listing_status]
        action: WILL_GET_CUSTOM_DATA,
    },
    LIST_MY_PROPERTY_CLICK: {
        category: CATEGORY,
        label: LABEL.CLICK,
        // ListMyProperty::[listing_status]
        action: WILL_GET_CUSTOM_DATA,
    },
};

export {
    GA_EVENTS,
    GA_PREFIX,
};
